import { render, staticRenderFns } from "./AuthorsDetail.vue?vue&type=template&id=78db4328&lang=html&"
import script from "./AuthorsDetail.vue?vue&type=script&lang=js&"
export * from "./AuthorsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports